var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 10,
    fill: "#FFDBF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2368 12.8999C18.0901 12.8999 13.106 16.7751 13.106 21.5572C13.106 24.1915 14.6231 26.5495 17.01 28.1532L15.9917 31.4512L19.3969 29.357C20.946 29.9299 22.5852 30.2203 24.2368 30.2144C30.3834 30.2144 35.3675 26.3393 35.3675 21.5572C35.3675 16.7751 30.3834 12.8999 24.2368 12.8999Z",
    fill: "#FF9999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7632 14.549C15.6166 14.549 10.6325 18.4241 10.6325 23.2062C10.6325 25.8405 12.1496 28.1986 14.5365 29.8022L13.5182 33.1002L16.9234 31.006C18.4724 31.5789 20.1117 31.8694 21.7632 31.8635C27.9099 31.8635 32.894 27.9883 32.894 23.2062C32.894 18.4241 27.9099 14.549 21.7632 14.549Z",
    fill: "#9AF43B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2644 30.6721L13.5182 33.1003L16.5194 31.2534C15.7525 31.1244 14.9981 30.93 14.2644 30.6721Z",
    fill: "#54596E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3156 14.549C26.7803 15.6868 30.0082 18.9477 30.0082 22.794C30.0082 27.5761 25.0241 31.4512 18.8774 31.4512C18.6919 31.4512 18.5105 31.4512 18.325 31.4512C19.4498 31.7291 20.6046 31.8676 21.7632 31.8635C27.9099 31.8635 32.894 27.9883 32.894 23.2062C32.894 18.5684 28.2067 14.7839 22.3156 14.549Z",
    fill: "#54596E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5877 21.5572C23.043 21.5572 23.4122 21.1881 23.4122 20.7327C23.4122 20.2773 23.043 19.9082 22.5877 19.9082C22.1323 19.9082 21.7632 20.2773 21.7632 20.7327C21.7632 21.1881 22.1323 21.5572 22.5877 21.5572Z",
    fill: "#54596E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5795 21.5572C16.0348 21.5572 16.404 21.1881 16.404 20.7327C16.404 20.2773 16.0348 19.9082 15.5795 19.9082C15.1241 19.9082 14.755 20.2773 14.755 20.7327C14.755 21.1881 15.1241 21.5572 15.5795 21.5572Z",
    fill: "#54596E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5877 23.6185C23.0431 23.6185 23.4122 23.2493 23.4122 22.794C23.4122 22.3386 23.0431 21.9695 22.5877 21.9695C22.1324 21.9695 21.7632 22.3386 21.7632 22.794C21.7632 23.2493 22.1324 23.6185 22.5877 23.6185Z",
    fill: "#61C5A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5795 23.6185C16.0348 23.6185 16.404 23.2493 16.404 22.794C16.404 22.3386 16.0348 21.9695 15.5795 21.9695C15.1241 21.9695 14.755 22.3386 14.755 22.794C14.755 23.2493 15.1241 23.6185 15.5795 23.6185Z",
    fill: "#61C5A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8775 26.5042C19.7882 26.5042 20.5265 25.5814 20.5265 24.443C20.5265 23.3046 19.7882 22.3817 18.8775 22.3817C17.9668 22.3817 17.2285 23.3046 17.2285 24.443C17.2285 25.5814 17.9668 26.5042 18.8775 26.5042Z",
    fill: "#54596E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8775 26.0918C19.3328 26.0918 19.702 25.9073 19.702 25.6796C19.702 25.4519 19.3328 25.2673 18.8775 25.2673C18.4221 25.2673 18.053 25.4519 18.053 25.6796C18.053 25.9073 18.4221 26.0918 18.8775 26.0918Z",
    fill: "#FF927D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment2);
export default __webpack_public_path__ + "static/media/comment2.22d581cdb07bd32542dbf1636379dc3e.svg";
export { ForwardRef as ReactComponent };